module.exports = __webpack_public_path__ + "media/assets/plane-14-color-eb027be9accb9e232b0fcca9514ba2a8.svg";